/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CarSharingPromotionType {
    SHARING_SITE = 'SHARING_SITE',
    OTHER = 'OTHER',
}
